import { render } from "./AIPopup.vue?vue&type=template&id=5e6fc8ea&scoped=true"
import script from "./AIPopup.vue?vue&type=script&lang=js"
export * from "./AIPopup.vue?vue&type=script&lang=js"

import "@/assets/css/components/commonPopup_v2.css?vue&type=style&index=0&id=5e6fc8ea&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6fc8ea"]])

export default __exports__